<template>
  <div
    class="helper-text-component"
    :class="[theme]"
  >
    <template v-if="isDefaultTheme">
      <div
        v-if="icon"
        class="helper-text-icon"
        :class="getIconClasses"
      >
        <template v-if="icon === 'attention'">
          !
        </template>
        <template v-if="icon === 'question'">
          ?
        </template>
        <template v-if="icon === 'info'">
          i
        </template>
      </div>

      <div class="helper-text-content">
        <slot />
      </div>
    </template>

    <template v-if="isBlueFlatTheme">
      <slot />
    </template>
  </div>
</template>

<script lang="ts">
const HELPER_TEXT_ICONS = ['attention', 'question', 'info'];
const HELPER_TEXT_THEMES = ['default', 'blue-flat'];
export default defineComponent({
	name: 'VHelperText',

	props: {
		icon: {
			type: String,
			default: null,
			validator: value => HELPER_TEXT_ICONS.includes(value),
		},
		theme: {
			type: String,
			default: 'default',
			validator: value => HELPER_TEXT_THEMES.includes(value),
		},
	},

	computed: {
		getIconClasses() {
			if (!this.icon) return null;
			return [this.icon];
		},
		isDefaultTheme() {
			return !(
				typeof this.theme === 'string'
				&& this.theme !== 'default'
				&& HELPER_TEXT_THEMES.findIndex(item => this.theme === item) > -1
			);
		},
		isBlueFlatTheme() {
			return this.theme === 'blue-flat';
		},
	},
});
</script>

<style lang="scss" src="./VHelperText.scss" />
